module.exports = __webpack_public_path__ + "static/install-livesession-c4a28f79bf3901d945bdf4d06715b2ab.png";